import { render, staticRenderFns } from "./AbsenBulanRamadhan.vue?vue&type=template&id=e22ddaf4&scoped=true"
import script from "./AbsenBulanRamadhan.vue?vue&type=script&lang=js"
export * from "./AbsenBulanRamadhan.vue?vue&type=script&lang=js"
import style0 from "./AbsenBulanRamadhan.vue?vue&type=style&index=0&id=e22ddaf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22ddaf4",
  null
  
)

export default component.exports